export enum CrashTrenballColor {
  Orange = 'orange',
  Yellow = 'yellow',
  Green = 'green',
}
